import { createRouter, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/my.vue'),
  },
  {
    path: '/cardDetails',
    name: 'CardDetails',
    component: () => import('@/views/cardDetails.vue'),
  },
  {
    path: '/orderList',
    name: 'OrderList',
    component: () => import('@/views/orderList.vue'),
  },
  {
    path: '/serviceDetails',
    name: 'ServiceDetails',
    component: () => import('@/views/serviceDetails.vue'),
  },
  {
    path: '/applyService',
    name: 'ApplyService',
    component: () => import('@/views/applyService.vue'),
  },
  {
    path: '/bindPeople',
    name: 'BindPeople',
    component: () => import('@/views/bindPeople.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register.vue'),
  },
  {
    path: '/registerBind',
    name: 'RegisterBind',
    component: () => import('@/views/registerBind.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done()
})
export default router
